import { render, staticRenderFns } from "./ItemFilterGalleryMyLayout.vue?vue&type=template&id=4870ed24&scoped=true"
import script from "./ItemFilterGalleryMyLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterGalleryMyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870ed24",
  null
  
)

export default component.exports